/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { ASSETS_TABLE } from "../pages/OwnedAssetTable/graphql/asset-table.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";

const MODULE_NAME = "OwnedAssetTableService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class OwnedAssetTableService {
    private static instance: OwnedAssetTableService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): OwnedAssetTableService {
        if (!OwnedAssetTableService.instance) {
            OwnedAssetTableService.instance = new OwnedAssetTableService(props);
        }
        return OwnedAssetTableService.instance;
    }

    async getOwnedAssetTable() {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: ASSETS_TABLE,
                    variables: {
                        assetTableCriteria: {
                            state: ["minted"]
                        },
                        assetTableOffset: 0,
                        assetTableSize: 5000,
                    },
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "getOwnedAssetTable: ", res);
                if(res?.data?.getMintedAssetTable){

                    return res?.data?.getMintedAssetTable;
                }
            }
        } catch (err) {}
    }
}
